import React from "react";
import { atomobj } from "../C";
import { useRecoilState } from "recoil";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SingleMAP from "./SingleMAP";
import "./ParticularAlert.css"; // Import your CSS file for styling
import { lighten } from "polished"; // Import the `lighten` function from polished


export default function ParticularAlert() {
  const nav = useNavigate();

  const [msg, setmsg] = useRecoilState(atomobj);

  useEffect(() => {
    console.log(msg);

    if (msg === "RECOILATOMISEMPTY") {
      nav("/");
    }
  }, []);



  return (
    <div className="alert-container" >
      <div className="alert-header" >
        {msg.disaster_type} 
      </div>


      <div className="alert-header">
         {msg.area_description}
      </div>





      <div className="map-container">
        <SingleMAP coordinate={msg.centroid} colour={msg.severity_color}/>
      </div>
      <div className="alert-details">
    
        <div className="alert-item">
          <div className="alert-label">Area Covered:</div>
          <div className="alert-value">{msg.area_covered}</div>
        </div>
        <div className="alert-item">
          <div className="alert-label">Disaster:</div>
          <div className="alert-value">{msg.disaster_type}</div>
        </div>
        <div className="alert-item">
          <div className="alert-label">Risk :</div>
          <div className="alert-value">{msg.severity_color ==="yellow"?<>Low</>:<>{msg.severity_color ==="red"?<>HIGH</>:<>MODERATE</>}</>}</div>
        </div>
        <div className="alert-item">
          <div className="alert-label"> Start Time:</div>
          <div className="alert-value">{msg.effective_start_time}</div>
        </div>
        <div className="alert-item">
          <div className="alert-label">End Time:</div>
          <div className="alert-value">{msg.effective_end_time}</div>
        </div>
        <div className="alert-item">
          <div className="alert-label">Warning:</div>
          <div className="alert-value">{msg.warning_message}</div>
        </div>
      </div>
    </div>
  );
}
